import React from 'react';

import { InterventionDetail } from 'components';

export const PageInterventionDetail = () => (
  <InterventionDetail />
);
